const LOCAL_KEY = 'ADA_USER';

export const adaUtil = {
  init(lang = 'en', onload = null, robotInfo = null) {
    if (window.adaEmbed) {
      return;
    }
    window.adaSettings = {
      language: lang,
    };
    const script = document.createElement('script');
    script.id = '__ada';
    script.defer = true;
    script.src = '//static.ada.support/embed2.js';
    // prod2: phemex-gen, prod1: phemex, sandbox: demo-sandbox-phemex
    script.setAttribute('data-handle', 'phemex-gen');
    script.type = 'text/javascript';
    script.onload = function () {
      onload && onload();
    };
    document.head.appendChild(script);
  },
  changeUserInfo(userInfo, tags) {
    const localUser = readAdaUser();
    if (userInfo.userId > 0) {
      const metaFields = {
        name: userInfo.nickName,
        email: userInfo.email,
        tags,
      };
      writeAdaUser(userInfo.userId);
      window.adaEmbed.reset({language: userInfo.lang, metaFields, resetChatHistory: localUser != userInfo.userId});
      return;
    }
    if (localUser) {
      writeAdaUser('');
      window.adaEmbed.deleteHistory();
    }
  },
  async openChat() {
    await chatAction('open');
  },

  async hideChat() {
    await chatAction('hide');
  },
};

async function chatAction(action) {
  if (!window.adaEmbed) {
    return;
  }
  const {isChatOpen} = await window.adaEmbed.getInfo();
  if ((action === 'open' && !isChatOpen) || (action === 'hide' && isChatOpen)) {
    window.adaEmbed.toggle(); // 展开/收起
  }
}

function readAdaUser() {
  return localStorage.getItem(LOCAL_KEY);
}

function writeAdaUser(user) {
  localStorage.setItem(LOCAL_KEY, user);
}
